import BannerInfo from 'components/BannerInfo';
import Card from 'components/Card';
import RegisterCompleted from 'components/RegisterCompleted';

const Completed = () => {
  return (
    <>
      <Card>
        <RegisterCompleted />
      </Card>
      <BannerInfo />
    </>
  );
};

export default Completed;
